import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useUpdateSbatGroupAcademyTopicMutation } from '@classCreation/services/sbatGroupAcademyTopicService';
import AcademyTopicInput from '../AcademyTopicInput';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import useSbatGroupConfirmation from '@classCreation/hooks/useSbatGroupConfirmation';

export default function EditSbatGroupAcademyTopicForm({
  sbatGroup,
  isEditing,
  setIsEditing,
}) {
  const [topic, setTopic] = useState(sbatGroup.academy_topic);
  const [
    updateAcademyTopic,
    { isSuccess, error, isLoading: isUpdating, reset },
  ] = useUpdateSbatGroupAcademyTopicMutation();

  const handleAcademyTopicUpdate = useCallback(() => {
    updateAcademyTopic({
      sbatGroupId: sbatGroup.id,
      academyTopic: topic,
    });
  }, [sbatGroup.id, topic, updateAcademyTopic]);

  const handleSubmit = useSbatGroupConfirmation(
    handleAcademyTopicUpdate,
    sbatGroup
  );

  useEffect(() => {
    if (!isEditing) {
      setTopic(sbatGroup.academy_topic);
      if (error) {
        reset();
      }
    }
  }, [sbatGroup.academy_topic, isEditing, reset, error]);

  const handleAcademyTopicChange = useCallback((newTopic) => {
    setTopic(newTopic);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Class is updated successfully!');
      setIsEditing(false);
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in updating the class. Please try again later!'
      );
    }
  }, [error, isSuccess, setIsEditing]);

  return (
    <Form onSubmit={handleSubmit}>
      <AcademyTopicInput
        value={topic}
        disabled={!isEditing}
        onChange={handleAcademyTopicChange}
      />
      <FieldErrors
        name="title"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="junction_number"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="academy_module_id"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="bucket_id"
        errors={error?.data?.errors}
      />
      {isEditing && (
        <Tappable
          component="button"
          type="submit"
          disabled={isUpdating}
          className="btn btn-primary btn-long m-t-xs"
        >
          Update Class
        </Tappable>
      )}
    </Form>
  );
}
